module.exports = __webpack_public_path__ + "assets/img/4e6ac2c902f5086dfd8716911ddf45e4.svg";